import { helper as buildHelper } from '@ember/component/helper';
import Moment from 'moment';

/**
 * Generates a formatted string of metadata for an asset.
 */
export function getAssetMetadata(params) {
  const [ asset, currentUser ] = params;

  const uploaderID = asset.get('uploader.id');
  const currentUserID = currentUser.get('id');

  let name;

  if (!uploaderID) {
    name = 'Unknown';
  } else if (uploaderID === currentUserID) {
    name = 'You';
  } else {
    name = `${asset.get('uploader.firstName')} ${asset.get('uploader.lastName')}`;
  }

  const date = Moment(asset.get('createdAt')).format('MM/DD/YYYY');

  return `${name} • ${date}`;
}

export default buildHelper(getAssetMetadata);
